import { FuseAlertModule } from './../../../../@fuse/components/alert/alert.module';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { AlertPanelComponent } from './alert-panel.component';

@NgModule({
    declarations: [
        AlertPanelComponent
    ],
    imports     : [
        SharedModule,
        FuseAlertModule
    ],
    exports     : [
        AlertPanelComponent
    ]
})
export class AlertPanelModule
{
}
